module.exports = __webpack_public_path__ + "ecd8a3e6a1efaf2ec8b73611b1dac138.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/MobileCollege_White@2x.png
// module id = 114
// module chunks = 0